/**
 * Remove trailing zeros from the end of a currency value string.
 * @param {string} value - The value string to process.
 * @returns {string} - The processed value string.
 */
export const simplifyDecimal = (value) => {
  // Split the value string into parts separated by the decimal point
  const parts = value.split(".");

  // If there are no parts after splitting or the last part is not just zeros, return the original string
  if (parts.length === 1 || !/^0+$/.test(parts[1])) {
    return value;
  }

  // Return everything that is not decimal
  return parts[0];
};
